export const START_PROCCESS_BOOK = "START_PROCCESS_BOOK";
export const END_PROCCESS_BOOK = "END_PROCCESS_BOOK";
export const SET_ALL_BOOKS = "SET_ALL_BOOKS";
export const GET_DATA_FAIL_BOOK = "GET_DATA_FAIL_BOOK";


